var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.999,
    height: 10.978,
    viewBox: "0 0 10.999 10.978",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H10.999V10.978H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    d: "M.688 10.978A.688.688 0 0 1 0 10.229l.26-2.865a1.356 1.356 0 0 1 .395-.834L6.84.349A1.236 1.236 0 0 1 7.726 0a1.4 1.4 0 0 1 .981.4l1.882 1.881a1.323 1.323 0 0 1 .048 1.866l-6.186 6.177a1.355 1.355 0 0 1-.835.39l-2.866.261zm4.8-7.336L1.627 7.5l-.181 2.03 2.046-.186 3.85-3.852-1.853-1.85zm2.26-2.259L6.41 2.722l1.852 1.851L9.6 3.234 7.749 1.383z",
    className: "cls-2"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-2{fill:#007dc3}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    d: "M.688 10.978A.688.688 0 0 1 0 10.229l.26-2.865a1.356 1.356 0 0 1 .395-.834L6.84.349A1.236 1.236 0 0 1 7.726 0a1.4 1.4 0 0 1 .981.4l1.882 1.881a1.323 1.323 0 0 1 .048 1.866l-6.186 6.177a1.355 1.355 0 0 1-.835.39l-2.866.261zm4.8-7.336L1.627 7.5l-.181 2.03 2.046-.186 3.85-3.852-1.853-1.85zm2.26-2.259L6.41 2.722l1.852 1.851L9.6 3.234 7.749 1.383z",
    className: "cls-2"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.1eaa9825.svg";
export { ForwardRef as ReactComponent };